import {
  CardPresentation,
  Image as ImageType,
  ListStyle,
} from '@yleisradio/areena-types';
import Image, { ImageLoader } from 'next/image';
import classNames from 'classnames';
import { defaultLoader, loaderUrl } from 'utils/cloudinary';
import styles from './CardImage.module.scss';
import React from 'react';

interface CardImageProps {
  image: ImageType | undefined;
  imageStyle: ListStyle['image'] | undefined;
  sizes: string;
  cardPresentation: CardPresentation | undefined;
  loader?: ImageLoader | undefined;
}

const getPresentationClassName = (
  presentation: CardPresentation | undefined
) => {
  switch (presentation) {
    case 'packageCard':
      return styles.packageCard;
    default:
      return null;
  }
};

function getImageStyleClassName(
  imageStyle: ListStyle['image'] | undefined
): string | undefined {
  switch (imageStyle) {
    case '1:1':
      return styles['aspectRatio_1_1'];
    case '9:13':
      return styles['aspectRatio_9_13'];
    case '16:9':
    default:
      return undefined;
  }
}

export const CardImage: React.FunctionComponent<CardImageProps> = ({
  image,
  imageStyle,
  sizes,
  cardPresentation,
  loader = defaultLoader,
}) => {
  if (imageStyle === 'none') return null;

  return (
    <div
      className={classNames(
        styles.container,
        getImageStyleClassName(imageStyle)
      )}
    >
      {image ? (
        <Image
          key={image.id}
          alt={image.alt || ''}
          className={classNames(
            styles.image,
            getPresentationClassName(cardPresentation)
          )}
          fill
          loader={loader}
          role={image.alt ? undefined : 'presentation'}
          sizes={sizes}
          src={loaderUrl(image)}
        />
      ) : null}
    </div>
  );
};
